import React, { memo } from 'react';
import PropTypes from 'prop-types';

import CreateFromScratchCard from '../CreateFromScratchCard';
import PredefinedTemplateCard from '../PredefinedTemplateCard';

/** Grid: unified scratch card plus API templates (search filtered server-side via `name`). */
const TemplatesGrid = memo(
    ({ footerPreview, templates, onSelectScratchHtml, onSelectScratchVisual, onUsePredefined }) => {
        return (
            <div className="marketing-templates-grid">
                <CreateFromScratchCard
                    onSelectHtml={onSelectScratchHtml}
                    onSelectVisual={onSelectScratchVisual}
                />
                {templates.map((row, index) => (
                    <PredefinedTemplateCard
                        key={row.id != null ? String(row.id) : `tpl-${index}`}
                        footerPreview={footerPreview}
                        template={row}
                        onUseTemplate={onUsePredefined}
                    />
                ))}
            </div>
        );
    },
);

TemplatesGrid.displayName = 'TemplatesGrid';

TemplatesGrid.propTypes = {
    footerPreview: PropTypes.shape({
        senderName: PropTypes.string,
        senderAddress: PropTypes.string,
        footerHere: PropTypes.string,
        linkHref: PropTypes.string,
    }),
    onSelectScratchHtml: PropTypes.func,
    onSelectScratchVisual: PropTypes.func,
    onUsePredefined: PropTypes.func,
    templates: PropTypes.arrayOf(PropTypes.object),
};

export default TemplatesGrid;
